import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";
import {TbBuildingStore, TbCar,  TbCodeDots,  TbSun} from "react-icons/tb";


function Vendor() {


    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [isEdited, setIsEdited] = React.useState(0);
    const [tropical, setTropical] = React.useState(0);
    const [carProducer, setCarProducer] = React.useState(0);

    const [brand, setBrand] = React.useState('');
    const [vendor, setVendor] = React.useState([]);
    const [basics, setBasics] = React.useState([]);

    const [light, setLight] = React.useState('');
    const [light2, setLight2] = React.useState('');
    const [light3, setLight3] = React.useState('');

    const [heavy, setHeavy] = React.useState('');
    const [heavy2, setHeavy2] = React.useState('');
    const [heavy3, setHeavy3] = React.useState('');

    const [motor, setMotor] = React.useState('');
    const [motor2, setMotor2] = React.useState('');
    const [motor3, setMotor3] = React.useState('');

    const [vrla, setVrla] = React.useState('');
    const [vrla2, setVrla2] = React.useState('');
    const [vrla3, setVrla3] = React.useState('');

    const [vrlal, setVrlal] = React.useState('');
    const [vrlal2, setVrlal2] = React.useState('');
    const [vrlal3, setVrlal3] = React.useState('');

    const [vrlam, setVrlam] = React.useState('');
    const [vrlam2, setVrlam2] = React.useState('');
    const [vrlam3, setVrlam3] = React.useState('');

    const [agm1, setAgm1] = React.useState('');
    const [agm2, setAgm2] = React.useState('');
    const [agm3, setAgm3] = React.useState('');
    const [efb1, setEfb1] = React.useState('');
    const [efb2, setEfb2] = React.useState('');
    const [efb3, setEfb3] = React.useState('');


    React.useEffect(() => {


        API.getVendor(id)
            .then((response) => {
                setVendor(response.data);
                setTropical(response.data.is_tropical)
                setCarProducer(response.data.is_car_producer)
                const params = {
                    'processFor': 'Sales',

                }
                API.getBasics(params)
                    .then((response) => {
                        setBasics(response.data)
                        setIsLoaded(true)
                    })
                    .catch((error) => {

                    });

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                }
            });


    }, [id]);


    const onDeleteClick = (theBrand) => {
        const request = {
            vendor_id: id,
            brand : theBrand,
            delete: 1
        }

        setIsLoaded(false);
        API.storeWarranties(request)
            .then((response) => {
                toast.success(response.message);
                API.getVendor(id)
                    .then((response) => {
                        setVendor(response.data);
                        setIsLoaded(true);
                    })
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }
    const onButtonClick = () => {

        if (brand.length < 2) {
            toast.error('برند را انتخاب کنید');
            return false;
        }
        const request = {
            vendor_id: id,
            brand,
            light,
            light2,
            light3,
            heavy,
            heavy2,
            heavy3,
            motor,
            motor2,
            motor3,
            vrla,
            vrla2,
            vrla3,
            vrlam,
            vrlam2,
            vrlam3,
            vrlal,
            vrlal2,
            vrlal3,
            agm1,
            agm2,
            agm3,
            efb1,
            efb2,
            efb3,
            edit: isEdited,
        }

        setIsLoaded(false);
        API.storeWarranties(request)
            .then((response) => {
                toast.success(response.message);
                API.getVendor(id)
                    .then((response) => {
                        setVendor(response.data);
                        setIsLoaded(true);
                    })
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setBrand('')
        setIsEdited(0)

    }

    return (
        <React.Fragment>
            <Header/>

            <Navbar page="vendors"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت گارانتی نماینده
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <TbBuildingStore/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                            عنوان:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {vendor?.title}
                                            &nbsp;
                                            (
                                            {vendor?.city}
                                            )
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <HiOutlineQrcode/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد تفصیل:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {vendor?.code}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3  border-bottom pb-2">
                                        <div className="col-1">
                                            <TbCodeDots/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد سامانه تجارت
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {vendor?.trade_system_code}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3  ">
                                        <div className="col-1">
                                            <TbSun/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                           نماینده مناطق گرم سیری
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            <div
                                                className="form-check form-switch text-primary">
                                                <input className="form-check-input"
                                                       type="checkbox" role="switch"
                                                       id='tropical'
                                                       checked={tropical}
                                                       onChange={(val) => {
                                                           setTropical(val.target.checked? 1: 0)
                                                           const params = {
                                                               'is_tropical': val.target.checked? 1: 0,
                                                               vendor_id: id,
                                                           }
                                                           API.updateVendor(params)
                                                               .then((response) => {
                                                                   toast.success(response.message);
                                                               })
                                                               .catch((error) => {
                                                                   toast.error(error.response.data.message);
                                                               });
                                                       }}

                                                />
                                                <label className="form-check-label "
                                                       htmlFor="tropical"
                                                       role="button">

                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3  ">
                                        <div className="col-1">
                                            <TbCar/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                           نماینده خودرو ساز
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            <div
                                                className="form-check form-switch text-primary">
                                                <input className="form-check-input"
                                                       type="checkbox" role="switch"
                                                       id='tropical'
                                                       checked={carProducer}
                                                       onChange={(val) => {
                                                           setCarProducer(val.target.checked? 1: 0)
                                                           const params = {
                                                               'is_car_producer': val.target.checked? 1: 0,
                                                               vendor_id: id,
                                                           }
                                                           API.updateVendor(params)
                                                               .then((response) => {
                                                                   toast.success(response.message);
                                                               })
                                                               .catch((error) => {
                                                                   toast.error(error.response.data.message);
                                                               });
                                                       }}

                                                />
                                                <label className="form-check-label "
                                                       htmlFor="tropical"
                                                       role="button">

                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer py-0">
                                    <div className='row bg-light py-3'>
                                        <div className="col-12 text-small-2 fw-bold ">
                                            ثبت گارانتی
                                        </div>
                                        <div className="col-12 my-3">
                                            <select
                                                className="form-control text-center text-small-1"
                                                id="floatingInput"
                                                disabled={isEdited}
                                                value={brand}
                                                onChange={
                                                    (event) => {
                                                        setBrand(event.target.value)
                                                    }
                                                }
                                            >
                                                <option value="0">
                                                    انتخاب برند
                                                </option>
                                                {
                                                    basics?.brands?.map(bt => {
                                                        return (
                                                            <option value={bt.name} key={bt.id}>
                                                                {bt.name}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div className="col-12 text-muted text-small-2 py-2">
                                            سبک
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={light}
                                                       onChange={
                                                           (val) => {
                                                               setLight(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={light2}
                                                       onChange={
                                                           (val) => {
                                                               setLight2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={light3}
                                                       onChange={
                                                           (val) => {
                                                               setLight3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 text-muted text-small-2 py-2">
                                            سنگین
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={heavy}
                                                       onChange={
                                                           (val) => {
                                                               setHeavy(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={heavy2}
                                                       onChange={
                                                           (val) => {
                                                               setHeavy2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={heavy3}
                                                       onChange={
                                                           (val) => {
                                                               setHeavy3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>


                                        <div className="col-12 text-muted text-small-2 py-2">
                                            AGM
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={agm1}
                                                       onChange={
                                                           (val) => {
                                                               setAgm1(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={agm2}
                                                       onChange={
                                                           (val) => {
                                                               setAgm2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={agm3}
                                                       onChange={
                                                           (val) => {
                                                               setAgm3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>


                                        <div className="col-12 text-muted text-small-2 py-2">
                                            EFB
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={efb1}
                                                       onChange={
                                                           (val) => {
                                                               setEfb1(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={efb2}
                                                       onChange={
                                                           (val) => {
                                                               setEfb2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={efb3}
                                                       onChange={
                                                           (val) => {
                                                               setEfb3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>


                                        <div className="col-12 text-muted text-small-2 py-2">
                                            موتورسیکلت
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={motor}
                                                       onChange={
                                                           (val) => {
                                                               setMotor(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={motor2}
                                                       onChange={
                                                           (val) => {
                                                               setMotor2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={motor3}
                                                       onChange={
                                                           (val) => {
                                                               setMotor3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 text-muted text-small-2 py-2">
                                            VRLA Small
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={vrla}
                                                       onChange={
                                                           (val) => {
                                                               setVrla(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={vrla2}
                                                       onChange={
                                                           (val) => {
                                                               setVrla2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={vrla3}
                                                       onChange={
                                                           (val) => {
                                                               setVrla3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>


                                        <div className="col-12 text-muted text-small-2 py-2">
                                            VRLA Medium
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={vrlam}
                                                       onChange={
                                                           (val) => {
                                                               setVrlam(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={vrlam2}
                                                       onChange={
                                                           (val) => {
                                                               setVrlam2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={vrlam3}
                                                       onChange={
                                                           (val) => {
                                                               setVrlam3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 text-muted text-small-2 py-2">
                                            VRLA Large
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت گارانتی (روز)"
                                                       value={vrlal}
                                                       onChange={
                                                           (val) => {
                                                               setVrlal(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مدت ماندگاری (روز)"
                                                       value={vrlal2}
                                                       onChange={
                                                           (val) => {
                                                               setVrlal2(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-2">
                                            <div className="mb-3">

                                                <input type="number"
                                                       className="form-control text-center text-small-1"
                                                       placeholder="مهلت استفاده (روز)"
                                                       value={vrlal3}
                                                       onChange={
                                                           (val) => {
                                                               setVrlal3(val.target.value)
                                                           }
                                                       }

                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            &nbsp;
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <button className="btn btn-success w-100"
                                                    onClick={onButtonClick}
                                            >
                                                ثبت
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">
                                        لیست گارانتی های ثبت شده
                                    </h5>
                                    <div className='row'>
                                        <div className="col-12 table-responsive">

                                            <table className="table table-striped  text-small-2">
                                                <thead className='text-center'>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">برند</th>
                                                    <th scope="col">سبک</th>
                                                    <th scope="col">سنگین</th>
                                                    <th scope="col">AGM</th>
                                                    <th scope="col">EFB</th>
                                                    <th scope="col">موتورسیکلت</th>
                                                    <th scope="col">VRLA (Small - Medium - Large)</th>
                                                    <th scope="col">عملیات</th>
                                                </tr>
                                                </thead>
                                                <tbody className='text-center'>
                                                {
                                                    vendor.warranties?.map((w, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <th scope="row">{index + 1}</th>
                                                                <td>{w.brand_title}</td>
                                                                <td>{w.light}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.light2}
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.light3}
                                                                </td>
                                                                <td>{w.heavy}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.heavy2}
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.heavy3}
                                                                </td>
                                                                <td>{w.agm1}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.agm2}
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.agm3}
                                                                </td>
                                                                <td>{w.efb1}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.efb2}
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.efb3}
                                                                </td>
                                                                <td>{w.motor}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.motor2}
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.motor3}
                                                                </td>
                                                                <td>
                                                                    {w.vrla} -  {w.vrlam} -  {w.vrlal}
                                                                    &nbsp; روز
                                                                    <hr/>
                                                                    <span className='text-small-3 mx-1'>ماندگاری:</span>
                                                                    {w.vrla2} - {w.vrlam2} - {w.vrlal2}
                                                                    <br/>
                                                                    <span className='text-small-3 mx-1'>مهلت:</span>
                                                                    {w.vrla3} - {w.vrlam3} - {w.vrlal3}
                                                                </td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-info text-small-3 mx-2"

                                                                            onClick={() => {
                                                                                setBrand(w.brand_title);
                                                                                setLight(w.light)
                                                                                setLight2(w.light2)
                                                                                setLight3(w.light3)
                                                                                setHeavy(w.heavy)
                                                                                setHeavy2(w.heavy2)
                                                                                setHeavy3(w.heavy3)
                                                                                setMotor(w.motor)
                                                                                setMotor2(w.motor2)
                                                                                setMotor3(w.motor3)
                                                                                setVrla(w.vrla)
                                                                                setVrla2(w.vrla2)
                                                                                setVrla3(w.vrla3)
                                                                                setVrlam(w.vrlam)
                                                                                setVrlam2(w.vrlam2)
                                                                                setVrlam3(w.vrlam3)
                                                                                setVrlal(w.vrlal)
                                                                                setVrlal2(w.vrlal2)
                                                                                setVrlal3(w.vrlal3)
                                                                                setAgm1(w.agm1)
                                                                                setAgm2(w.agm2)
                                                                                setAgm3(w.agm3)
                                                                                setEfb1(w.efb1)
                                                                                setEfb2(w.efb2)
                                                                                setEfb3(w.efb3)
                                                                                setIsEdited(1)
                                                                                setTimeout(() => {
                                                                                    window.scrollTo({
                                                                                        top: 200,
                                                                                        behavior: 'smooth'
                                                                                    });
                                                                                }, 400)
                                                                            }}
                                                                    ><i className="bi bi-pen "></i> ویرایش
                                                                    </button>
                                                                    <button type="button"
                                                                            className="btn btn-danger text-small-3 mx-2"
                                                                            onClick={() => {
                                                                                onDeleteClick(w.brand_title)
                                                                            }}
                                                                    ><i className="bi bi-pen "></i> حذف
                                                                    </button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </section>
            </main>

        </React.Fragment>
    );
}

export default Vendor;